import { GradeCatalog } from "src/app/catalogs/models/grade-catalog.model";
import { PipesCatalog } from "src/app/catalogs/models/pipes-catalog.model";

export class DrillstringModel {
  public constructor(init?: Partial<DrillstringModel>) {
    Object.assign(this, init);
  }

  id: string;
  tubularStringId: string;
  drillPipe: PipesCatalog;
  drillPipeGrade?: GradeCatalog | null;
  heavyWeightDrillPipe: PipesCatalog;
  hwdpGrade?: GradeCatalog | null;
  collar: PipesCatalog;
  collarGrade?: GradeCatalog | null;
  hwdpLength: number;
  collarLength: number;
  designId?: string;
}